import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import horizontal_1 from "../../assests/images/horizontal_1.jpg";
import horizontal_2 from "../../assests/images/horizontal_2.jpg";
import GooglePlay from '../../assests/GooglePlay.png'
import AppleButton from '../../assests/AppleButton.svg'

const phoneImages = [horizontal_1, horizontal_2];

export default function SecondSectionApp() {
  const [index, setIndex] = useState(0);

  // Auto switch image (mobile & tablet)
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % phoneImages.length);
    }, 3000); // change every 3s

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-6">
        <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-8">
            NextLoop <span className="text-[#92abc4]">App</span>
          </h2>
        <div className="grid items-center gap-12 md:grid-cols-2">

          {/* LEFT – Image Showcase */}
          <div>
            {/* Desktop: static */}
            <div className="hidden lg:flex gap-6">
              {phoneImages.map((src, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.15 }}
                  viewport={{ once: true }}
                  className="w-[520px] h-[520px]"
                >
                  <img
                    src={src}
                    alt=""
                    className="h-full w-full rounded-[28px] object-cover shadow-xl"
                  />
                </motion.div>
              ))}
            </div>

            {/* Tablet & Mobile: fade swap */}
            <div className="relative lg:hidden w-[300px] h-[400px] mx-auto">
              <AnimatePresence mode="wait">
                <motion.img
                  key={index}
                  src={phoneImages[index]}
                  alt=""
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.8, ease: "easeInOut" }}
                  className="absolute inset-0 h-full w-full rounded-[28px] object-cover shadow-xl"
                />
              </AnimatePresence>
            </div>
          </div>

          {/* RIGHT – Text Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight">
              Find <span className="text-yellow-400">People</span>, Make <span className="text-yellow-400">Connections</span>, Unlock <span className="text-yellow-400">Opportunities</span>
            </h2>

            <ul className="mt-8 space-y-6 text-neutral-600">
              <li className="flex gap-4 items-start">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-yellow-400 text-white text-sm font-medium">
                  1
                </span>
                <div className="max-w-[calc(100%-3rem)]">
                  <p className="font-medium text-neutral-900">
                    Find People Like You
                  </p>
                  <p className="text-sm">
                    Discover others in your community with similar interests and goals.
                  </p>
                </div>
              </li>

              <li className="flex gap-4 items-start">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-yellow-400 text-white text-sm font-medium">
                  2
                </span>
                <div className="max-w-[calc(100%-3rem)]">
                  <p className="font-medium text-neutral-900">
                    Expand Your Network
                  </p>
                  <p className="text-sm">
                    Connect and interact with like-minded people to create meaningful relationships.
                  </p>
                </div>
              </li>

              <li className="flex gap-4 items-start">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-yellow-400 text-white text-sm font-medium">
                  3
                </span>
                <div className="max-w-[calc(100%-3rem)]">
                  <p className="font-medium text-neutral-900">
                    Power Other Services
                  </p>
                  <p className="text-sm">
                    Leverage connections to access additional features and services on NextLoop.
                  </p>
                </div>
              </li>
            </ul>

            {/* App Store & Google Play Buttons */}
            {/* App Store & Google Play Buttons */}
<div className="mt-10 flex flex-row gap-4 justify-start">
  <a
    href="https://play.google.com/store/apps/details?id=com.mycompany.nextlabor&hl=en-SG"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src={GooglePlay}
      alt="Get it on Google Play"
      className="w-48"
    />
  </a>
  <a
    href="https://apps.apple.com/sg/app/nextloop-rental-marketplace/id6535674656"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src={AppleButton}
      alt="Download on the App Store"
      className="w-48"
    />
  </a>
</div>


          </div>

        </div>
      </div>
    </section>
  );
}
